const $ = jQuery;
const isProductListPage = WCBT_GLOBAL_OBJECT.is_product_taxonomy_page || WCBT_GLOBAL_OBJECT.is_shop_page;

const wcbtVariation = () => {
	if ( typeof WCBT_VARIATION_OBJECT === 'undefined' ) {
		return;
	}

	if ( WCBT_VARIATION_OBJECT.mode !== 'on' ) {
		return;
	}

	changeSelectedName();
	addToCartButton();
};

//Display add to cart button in Product L
const addToCartButton = () => {
	//Change variation
	document.addEventListener( 'change', function( event ) {
		const target = event.target;

		const variationNode = target.closest( 'form.variations_form.cart' );
		if ( ! variationNode ) {
			return;
		}

		const productItem = target.closest( 'li.product' );
		if ( ! productItem ) {
			return;
		}

		const addToCartBtn = productItem.querySelector( '.woocommerce-variation-add-to-cart' );
		const selectOptionsBtn = productItem.querySelector( 'a.add_to_cart_button' );

		selectOptionsBtn.style.display = 'none';
		addToCartBtn.style.display = 'block';
	} );

	//Clear variation
	document.addEventListener( 'click', function( event ) {
		const target = event.target;

		if ( ! target.classList.contains( 'reset_variations' ) ) {
			return;
		}

		const productItem = target.closest( 'li.product' );
		if ( ! productItem ) {
			return;
		}

		const addToCartBtn = productItem.querySelector( '.woocommerce-variation-add-to-cart' );
		const selectOptionsBtn = productItem.querySelector( 'a.add_to_cart_button' );

		addToCartBtn.style.display = 'none';
		selectOptionsBtn.style.display = 'inline-block';
	} );
};

const changeSelectedName = () => {
	if ( WCBT_VARIATION_OBJECT.show_selected_name !== 'on' ) {
		return;
	}

	//Change Variation
	document.addEventListener( 'change', function( event ) {
		const target = event.target;

		const variationNode = target.closest( 'form.variations_form.cart' );
		if ( ! variationNode ) {
			return;
		}
		console.log( 'aaaa' );
		const trNode = target.closest( 'tr' );
		const labelNode = trNode.querySelector( 'td.label' );
		let textNode = target.closest( 'div' ).querySelector( 'label span' );

		//Text attr
		if ( ! textNode ) {
			textNode = target.closest( 'div' ).querySelector( 'label' );
		}

		const textValue = textNode.innerHTML;
		const spanNodes = labelNode.querySelectorAll( 'span' );
		[ ...spanNodes ].map( ( spanNode ) => {
			spanNode.remove();
		} );

		if ( textValue ) {
			labelNode.insertAdjacentHTML( 'beforeend', `<span>:</span><span>${ textValue }</span>` );
		}
	} );

	//Clear variation
	document.addEventListener( 'click', function( event ) {
		const target = event.target;

		if ( ! target.classList.contains( 'reset_variations' ) ) {
			return;
		}

		const spanNodes = target.closest( 'tbody' ).querySelectorAll( ' td.label span' );
		[ ...spanNodes ].map( ( spanNode ) => {
			spanNode.remove();
		} );
	} );
};

export default wcbtVariation;

